import React, {Component} from 'react';
import config from 'react-global-configuration';
import axios from "axios";
import jwt_decode from "jwt-decode";

class SendInvoiceToPaymentQueue extends Component {
    state = {
        host: 'https://{{host}}:{{port}}/integrationserver/sendInvoiceToPaymentQueue',
        header: 'Content-Type: application/json',
        rawdata: ' {',
        code: '"merchantid" : "{{merchantid}}"',
        code2: '"passcode" : "{{passcode}}"',
        codeClose: '}',
        purl: 'https://{{host}}:{{port}}/integrationserver/sendInvoiceToPaymentQueue',
        languageList: [],
        sourceCode: '',
        isDevOptionAccess: false
    }

    componentDidMount() {
        this.getDevOptionsPermission();
        axios.get(config.get('API_URL') + '/diyusers/getLanguageList',
            {
                headers: {
                    Authorization: ` ${localStorage.usertoken}`
                }
            })
            .then(response => {
                this.setState({
                    languageList: response.data.languages
                })
            })
            .catch(err => {
                console.log(err)
            });

        axios.post(config.get('API_URL') + '/diyusers/getCodeSinnpet',
            {
                language: 'csharp',
                variant: 'RestSharp',
                APIId: 1
            },
            {
                headers: {
                    Authorization: ` ${localStorage.usertoken}`
                }
            })
            .then(response => {
                //alert(response);
                this.setState({
                    sourceCode: response.data.snippet
                });
            })
            .catch(err => {
                console.log(err)
                //alert(err)
            });

    }

    getDevOptionsPermission() {
        const tokenPermission = localStorage.userPermission;
        const decoded_permission = jwt_decode(tokenPermission);
        let AllAccessPermissions = decoded_permission.accessPermissions;
        if(AllAccessPermissions !== undefined) {
            AllAccessPermissions.map((permissionName, i) => {
                if (permissionName.access_type == 'Action' && permissionName.access_name == 'advance_developer_option') {
                    this.setState({
                        isDevOptionAccess: true
                    })
                }
            });
        }
    }

    OnLanguageChange = (e) => {
        let languageValue = e.target.value;
        var value = this.state.languageList.filter(function (item) {
            return item.key == e.target.value
        })
        axios.post(config.get('API_URL') + '/diyusers/getCodeSinnpet',
            {
                language: languageValue,
                variant: value[0].variant,
                APIId: 1
            },
            {
                headers: {
                    Authorization: ` ${localStorage.usertoken}`
                }
            })
            .then(response => {
                //alert(response);
                this.setState({
                    sourceCode: response.data.snippet
                });
            })
            .catch(err => {
                console.log(err)
                //alert(err)
            });
    }

    renderInputField() {
        if (this.state.isDevOptionAccess === false) {
            return <div></div>;
        } else {
            let ltLanguage = this.state.languageList.map(data => {
                if (data.key == 'csharp') {
                    return <option selected value={data.key}>{data.label}</option>
                } else {
                    return <option value={data.key}>{data.label}</option>
                }
            })
            return (
                <div className="col-md-5 pCodeBody2">
                    <label htmlFor="cars">Choose a Language :</label> &nbsp;
                    <select id="Language" name="Language" className="langualeDrop" onChange={this.OnLanguageChange}>
                        <option value="">Select...</option>
                        {ltLanguage}
                    </select>

                    <h5 className="pCHead">Example Request</h5>
                    <div className="pCodeBox">
                        <div className="pcodeHead">
                            sendInvoiceToPaymentQueue
                        </div>
                        <div className="pcodeB">
                                        <pre>
                                            <code>
                                              {this.state.sourceCode}
                                            </code>
                                        </pre>

                        </div>
                    </div>
                </div>
            );
        }
    }

    render() {
        let ltLanguage = this.state.languageList.map(data => {
            if (data.key == 'csharp') {
                return <option selected value={data.key}>{data.label}</option>
            } else {
                return <option value={data.key}>{data.label}</option>
            }
        })
        return (
            <div>
                <div className="col-md-7 leftBody">
                    <br/>
                    <span className="post">POST</span> <span className="postHead"> sendInvoiceToPaymentQueue</span>
                    <br/>
                    <br/>
                    <span className="pUrl"> {this.state.purl} </span>
                    <br/>
                    <br/>
                    <p className="diyJustify">
                        This API would be used by Merchant Billing Server to save the store invoice details to Innoviti
                        Integration server. For example, whenever a bill is generated at the Store, the bill should be
                        sent to Innoviti Integration server by using this API.
                    </p>
                    <h6 className="diyTableBorFont">MANDATORY REQUEST PARAMETERS </h6>
                    <hr className="hrDiv" />
                    <table className="table-bordered diyTableBorFont">
                        <thead>
                        <tr>
                            <th className="diyTableBorFont p-l-5">Parameter</th>
                            <th className="diyTableBorFont p-l-5">Type</th>
                            <th className="diyTableBorFont p-l-5">Description</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr>
                            <td>storeCode</td>
                            <td>String</td>
                            <td>either storecode provided by Innoviti or merchant specific storecode with max length of
                                6
                            </td>
                        </tr>
                        <tr>
                            <td>innoStore</td>
                            <td>String</td>
                            <td>any of the two values are allowed (0 - Merchant is using the storecode which is provided
                                by Innoviti,1 – Merchant is using own storecode)
                            </td>
                        </tr>
                        <tr>
                            <td>billInvoiceNo</td>
                            <td>String</td>
                            <td>unique reference number generated by the Merchant Billing server</td>
                        </tr>
                        <tr>
                            <td>invoiceDate</td>
                            <td>Timestamp</td>
                            <td>date and time on which the invoice is generated - YYYY-MM-DD HH:MM:SS (format)</td>
                        </tr>
                        <tr>
                            <td>invoiceAmount</td>
                            <td>Numeric (12,2)</td>
                            <td>total invoice amount generated by the billing server</td>
                        </tr>
                        <tr>
                            <td>txnType</td>
                            <td>String</td>
                            <td>possible values are- 00 – Sale (default)</td>
                        </tr>
                        <tr>
                            <td>txnMode</td>
                            <td>String</td>
                            <td>Optional parameter - this represnts the mode of payment and possible values are 00 -
                                EFT, 86 - UPI, 17 - Gpay, 10 - EMI, 18 - PhonePe)
                            </td>
                        </tr>
                        <tr>
                            <td>utid</td>
                            <td>String</td>
                            <td>Optional parameter (this is the unique of an EDC machine. If merchant wants to link a
                                bill with a UTID, then this parameter needs to be passed. If this value is set, then
                                only this UTID would be allowed to take the payment for this bill further)
                            </td>
                        </tr>
                        <tr>
                            <td>mobileNo</td>
                            <td>String</td>
                            <td>Optional parameter (mobile number of the customer for whom this invoice is generated.
                                For example, for googlepay transaction mode, customer mobile number will be used for
                                payment e.g 88xxxxx446)
                            </td>
                        </tr>
                        <tr>
                            <td>invoiceDetails</td>
                            <td>JSON Object</td>
                            <td>Optional parameter (additional information which may be passed to Integration server)
                            </td>
                        </tr>
                        <tr>
                            <td></td>
                            <td></td>
                            <td>displayTag1 – String (display tag which can be shown along with invoice reference number
                                in the terminal)
                            </td>
                        </tr>
                        <tr>
                            <td></td>
                            <td></td>
                            <td>displayTag2 – String (display tag which can be shown along with invoice reference number
                                in the terminal)
                            </td>
                        </tr>
                        <tr>
                            <td></td>
                            <td></td>
                            <td>posID - String</td>
                        </tr>
                        <tr>
                            <td></td>
                            <td></td>
                            <td>cashierID – String</td>
                        </tr>
                        <tr>
                            <td></td>
                            <td></td>
                            <td>itemSKU : String</td>
                        </tr>
                        <tr>
                            <td></td>
                            <td></td>
                            <td>itemSerialNo : String</td>
                        </tr>
                        <tr>
                            <td></td>
                            <td></td>
                            <td>points : String</td>
                        </tr>
                        </tbody>
                    </table>

                    <br/>
                    <h6 className="diyTableBorFont">HEADERS </h6>
                    <hr className="hrDiv" />
                    <small> Content-Type &nbsp;&nbsp;&nbsp;&nbsp;application/json  </small>
                    <small> authToken &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{'{{token}}'} </small>
                    <br/>
<br />
                  <h6> BODY raw </h6>
                    <hr className="hrDiv" />
                    <span className="pUrlBody">
                            {'{'} <br/>
                        {'"storeCode":"L00167",'} <br/>
                        {'"billInvoiceNo":"bill58",'}<br/>
                        {'"invoiceDate":"2020-03-17 17:25:30",'}<br/>
                        {'"invoiceAmount":"99.99",'}<br/>
                        {'"utid":null,'}<br/>
                        {'"invoiceDetails":{'}<br/>
                        &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;  {'"displayTag1":"Jims",'}<br/>
                        &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;  {'"displayTag2":"Table-1",'}<br/>
                        &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;  {'"posID":"12369",'}<br/>
                        &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;  {'"cashierID":"7921",'}<br/>
                        &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;  {'"itemSKU":"null",'}<br/>
                        &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;  {'"itemSerialNo":"121233244",'}<br/>
                        &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;  {'"points":"25.2",'}<br/>
                        &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;{'},'}
                        <br/>
                        {'"txnType":"00",'}<br/>
                        {'"txnMode":"00",,'}<br/>
                        {'"innoStore":"0",,'}<br/>
                        {'"mobileNo":"8854475447",'}<br/>
                        {'}'}
                        <br/>

                        </span>
                </div>
                {this.renderInputField()}
            </div>
        );
    }
}

export default SendInvoiceToPaymentQueue;